import { useContext } from 'react'
import { GlobalContext } from '../../context/GlobalState';

export const useGeneraIdCarrello = () => {

    const debug = process.env.REACT_APP_DEBUG === "true"
    const { datiEnte, ente, provincia, servizio } = useContext(GlobalContext)


    if (debug) console.log('useGeneraIdCarrello', datiEnte, ente, provincia, servizio)


    const getDataFormattata = () => {
        let dataFormattata = ""

        let data = new Date()
        let anno = data.getFullYear()
        let mese = (data.getMonth() + 1).toString().padStart(2, '0')
        let giorno = data.getDate().toString().padStart(2, '0')
        let ora = data.getHours().toString().padStart(2, '0')
        let minuti = data.getMinutes().toString().padStart(2, '0')
        let secondi = data.getSeconds().toString().padStart(2, '0')
        let millisecondi = data.getMilliseconds().toString().padStart(3, '0')

        dataFormattata += anno
        dataFormattata += mese
        dataFormattata += giorno
        dataFormattata += ora
        dataFormattata += minuti
        dataFormattata += secondi
        dataFormattata += millisecondi

        return dataFormattata
    }


    const getRandomInt = (min, max) => {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min)
    }


    const generaStringa = (lunghezza) => {
        const caratteri = "1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM"

        let stringa = ""

        for(let i = 0; i < lunghezza; i++) {
            let index = getRandomInt(0, caratteri.length)
            let carattere = caratteri.charAt(index)
            stringa += carattere
        }

        return stringa
    }


    const generaIdCarrello = () => {
        let idCarrello = `RA_${getDataFormattata()}_${generaStringa(6)}`

        return idCarrello
    }


    return generaIdCarrello
}